module.exports = __webpack_public_path__ + "static/media/userlist-empty.15dd69ac.png";